<template>
    <!-- Hide footer if Portal is being displayed in an Iframe -->
    <div class="container text-center" v-if="!this.$store.getters.getRenderPagesInIframe">
        <div class="footer-img padding-bottom-5">
            <img :src="getFooterImageUrl" v-show="getFooterImageUrl !== ''" alt="Footer Logo" /><br />
        </div>

        <div class="footer-copyright padding-bottom-5" v-if="displayCopyrightAndPrivacySection">
            {{ $t("message.copyright") }} 2008-{{ new Date().getFullYear() }} 
            <span v-if="displayPrivacyLinkAndLanguages"><router-link to="/support">{{ $t("message.privacyPolicy") }}</router-link></span>
        </div>
        
        <!-- Display Languages in case of App Layout pages (all pages after user has been authenticated) OR if user is on Unsubscribe page -->
        <div class="footer-lang-links padding-bottom-5" v-if="(displayPrivacyLinkAndLanguages && displayLanguagesSection) || displayIfUnsubscribeRoute">
            <a href="#" @click.prevent="switchLanguage('en')">English</a>
            <a href="#" @click.prevent="switchLanguage('es')">Español</a>
        </div>  
    </div>    
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            supportedLanguages: this.$i18n.messages
        }
    },
    methods: {
        switchLanguage(language) {
            if (language in this.supportedLanguages) {
                this.$i18n.locale = language;
                this.$store.commit('setLanguage', language);
            }
        }
    },
    computed: {
        displayPrivacyLinkAndLanguages() {
            return this.$store.getters.getCurrentPageLayout === this.$LayoutType.AppLayout;
        },
        getFooterImageUrl() {
            return this.$store.getters.getFooterImage;
        },
        displayCopyrightAndPrivacySection() {
            return this.$store.getters.getDisplayCopyrightAndPrivacy;
        },
        displayLanguagesSection() {
            return this.$store.getters.getDisplayLanguages;
        },
        displayIfUnsubscribeRoute() {
            return this.$route.name === 'Unsubscribe';
        }
    }
}
</script>

<style scoped>
#simple-layout .container {
    width: 100%;
}

#app-layout .padding-bottom-5 {
    padding-bottom: 5px;
}

.router-link-active {
    background: none !important;
    color: #1473B3;
}
</style>